import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataSalesOrganisation } from '../types/masterdata-entities';
import { keyName } from './shared';

/** Sales organisation (Verkaufsorganisation). No default filter: the VKFORG
 *  response has no `active` field and the endpoint rejects the active-only leaf. */
export const MASTERDATA_SALES_ORGANISATION =
  defineMasterdataEntity<MasterdataSalesOrganisation>({
    name: 'sales-organisation',
    responseKey: 'salesOrganisations',
    displayWith: (s) => keyName(s.key, s.name),
    icon: 'fa-regular fa-store',
    title: 'Verkaufsorganisationssuche',
    label: 'Verkaufsorganisation',
    placeholder: 'Verkaufsorganisation suchen...',
    columns: [
      {
        label: 'Verkaufsorganisation',
        type: 'entity',
        icon: 'fa-regular fa-store',
        value: (e) => keyName(e.key, e.name),
      },
      { label: 'Schlüssel', type: 'text', value: (e) => e.key },
      { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
    ],
  });
